import Seo from "../components/Seo";
import NonAffiliationBanner from "../components/NonAffiliationBanner";

export default function About() {
  return (
    <>
      <Seo title="About" description="Learn about HS Library Hangout, an independently organized homeschool teen board game group near Oak Lawn, IL." />
      <h1>About HS Library Hangout</h1>
      <NonAffiliationBanner compact />
      <p>
        HS Library Hangout is a small, volunteer-run parent group that organizes informal board game
          gatherings for homeschooled teens (grades 8-12, ages 13-18) in the southwest
        suburbs of Chicago, Illinois. We meet at Oak Lawn Public Library, using public meeting room space
        like any other community group.
      </p>
      <p>
        Our goal is simple: give homeschooled teens a regular, low-pressure way to socialize over board
        games, with their parents present and engaged. We are not a business, a school program, or a
        library program &mdash; just a group of parents coordinating get-togethers for our own teens and
        anyone else who&rsquo;d like to join.
      </p>
      <h2>Who runs this?</h2>
      <p>
        HS Library Hangout is organized by homeschooling parents in the community, on a volunteer basis. If
        you have questions, please use our <a href="/contact">contact form</a>.
      </p>
    </>
  );
}
